import DocumentTaskService from 'services/task/subServices/documentTask/DocumentTaskService';

export default {
	'services.documentTaskService': {
		class: DocumentTaskService,
		deps: [{ $ref: 'services.taskStateService' }],
	},
};
